module.exports = __webpack_public_path__ + "tn.164b5a1710cde7f7a8cd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tn.svg
// module chunks = styles